/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChatByFormReceiverType {
    Location = 1,
    LocationGroup = 2,
}
